import EventModule from 'containers/purchase/modules/event_module/event_module'
import DayModule from 'containers/purchase/modules/day_module/day_module'
import TicketTypesModule from 'containers/purchase/modules/ticket_types_module/ticket_types_module'
import AccessModule from 'containers/purchase/modules/access_module/access_module'
import CouponModule from 'containers/purchase/modules/coupon_module/coupon_module'
import eventState from 'containers/purchase/modules/event_module/event_state'
import dayState from 'containers/purchase/modules/day_module/day_state'
import ticketTypesState from 'containers/purchase/modules/ticket_types_module/ticket_types_state'
import accessState from 'containers/purchase/modules/access_module/access_state'
import couponState from 'containers/purchase/modules/coupon_module/coupon_state'
import {get} from 'lodash'

const config = (params) => {
  const parameterGroups = get(params, 'user.user.parameter_groups', [])

  const portaventuraGroup = parameterGroups && parameterGroups.find((group) => group.code == 'portaventura_pos')

  const couponParameter = portaventuraGroup && portaventuraGroup.parameters && portaventuraGroup.parameters.find((parameter) => parameter.key == 'experticket_coupon_discount')

  const productSource = get(params, 'product.external_api_config.source')
  const isPortaventuraSource = (productSource == 'portaventura')

  const isCouponActive = (couponParameter && couponParameter.value == true) && isPortaventuraSource

  const mode = params.external_api_config && params.external_api_config.mode
  const filterSessionGroups = params.external_api_config && params.external_api_config.filterSessionGroups

  const reservationMapper = (ctx) => {
    let reservationParams = {}

    if (mode == 'session') {
      const session_groups = ctx.selection_groups.map((sg) => ({
        id: sg.id,
        access_date: sg.access_date,
        session: sg.session
      })).sort((a, b) => {
        if (a.access_date > b.access_date) {
          return 1
        }
        if (a.access_date < b.access_date) {
          return -1
        }

        return 0
      })

      reservationParams = {
        event_id: session_groups[0].session,
        ticket_types: ctx.tickets,
        params: {
          session_groups: session_groups,
        }
      }
    } else if (mode == 'event') {
      reservationParams = {
        access_date: ctx.event.time,
        event_id: ctx.event.id,
        ticket_types: ctx.tickets,
        params: {}
      }
    } else {
      reservationParams = {
        event_id: ctx.event.id,
        ticket_types: ctx.tickets,
        params: {}
      }
    }

    if (ctx.coupon) {
      reservationParams['params']['coupon_id'] = ctx.coupon
    }

    return reservationParams
  }

  let steps = {}

  if (isCouponActive == true) {
    steps['couponStep'] = {
      component: CouponModule,
      autoNext: false,
      states: couponState,
      context: {}
    }
  }


  if (mode == 'event') {
    steps['eventStep'] = {
      component: EventModule,
      autoNext: true,
      states: eventState,
      context: {
        year_month: params.initialYearMonth,
        event_groups: [],
        event: null
      }
    }
  } else {
    steps['dayStep'] = {
      component: DayModule,
      autoNext: true,
      states: dayState,
      context: {
        year_month: params.initialYearMonth,
        day: params.initialDate,
        event_groups: [],
        event: null
      }
    }
  }

  steps['ticketsStep'] = {
    component: TicketTypesModule,
    autoNext: false,
    states: ticketTypesState,
    context: {
      tickets: []
    }
  }

  if (mode == 'session') {
    steps['accessStep'] = {
      component: AccessModule,
      autoNext: false,
      states: accessState,
      context: {
        selection_groups: [],
        filterSessionGroups: filterSessionGroups
      }
    }
  }

  return {
    reservationMapper: reservationMapper,
    steps: steps
  }
}

export default config
